import { render, staticRenderFns } from "./successPage.vue?vue&type=template&id=8807a086&scoped=true&"
import script from "./successPage.vue?vue&type=script&lang=js&"
export * from "./successPage.vue?vue&type=script&lang=js&"
import style0 from "./successPage.vue?vue&type=style&index=0&id=8807a086&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8807a086",
  null
  
)

export default component.exports